import React, { Fragment, useRef, useState, useContext } from 'react';
import { AuthContext } from '../contexts/auth';
import { Dialog, Transition } from '@headlessui/react';
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';
import Toggle from './toggle';
import PDFUpladUnilav from './pdf_upload_unilav';
import XMLUploadUnilav from './xml_upload_unilav';
import { createDipendenteByUnilav } from '../services/api';
import Swal from 'sweetalert2';

const UploadUnilavEmployee = ({ closeModalUploadUnilav }) => {
    const { token } = useContext(AuthContext);
    const cancelButtonRef = useRef(null);
    const [selectedOption, setSelectedOption] = useState('PDF');
    const [file, setFile] = useState(null);
    const [unilavType, setUnilavType] = useState('');
    const [response, setResponse] = useState('');

    const uploadFile = (file) => {
        setFile(file);
    };

    const handleTypeChange = (type) => {
        setUnilavType(type);
    };

    const handlePDFUpload = async () => {
        if (!file || !unilavType) {
            setResponse('Seleziona un file PDF e un tipo di Unilav.');
            return;
        }
    
        const formData = new FormData();
        formData.append('myfile', file);
        formData.append('type', 'pdf');
        formData.append('pdf_format', unilavType);

        try {
            const result = await createDipendenteByUnilav(token, formData);
            setResponse(`Dipendente creato con ID: ${result.id}`);

            const swalResult = await Swal.fire({
                icon: "success",
                title: "Dipendente creato con successo!",
                text: "Vai all'anagrafica appena creata e compila il campo Email per abilitare l'accesso all'app HR",
                confirmButtonText: "Vai",
                showCancelButton: true,
                cancelButtonText: "Annulla",
            });

            if (swalResult.isConfirmed) {
                window.location.href = `/dipendenti/${result.cf}/edit`;
            }

            closeModalUploadUnilav();
        } catch (error) {
            console.log('error', error);

            if (error.response && error.response.data && error.response.data.error) {
                const errorMessage = error.response.data.error;
                Swal.fire('Errore...', errorMessage, 'error');
            } else {
                Swal.fire('Errore...', error.message || 'Errore sconosciuto', 'error');
            }
        }
    };

    const handleXMLUpload = async () => {
        if (!file) {
            setResponse('Seleziona un file XML');
            return;
        }

        const formData = new FormData();
        formData.append('myfile', file);
        formData.append('type', 'xml');

        try {
            const result = await createDipendenteByUnilav(token, formData);
            setResponse(`Dipendente creato con ID: ${result.id}`);

            const swalResult = await Swal.fire({
                icon: "success",
                title: "Dipendente creato con successo!",
                text: "Vai all'anagrafica appena creata e compila il campo Email per abilitare l'accesso all'app HR",
                confirmButtonText: "Vai",
                showCancelButton: true,
                cancelButtonText: "Annulla",
            });

            if (swalResult.isConfirmed) {
                window.location.href = `/dipendenti/${result.cf}/edit`;
            }

            closeModalUploadUnilav();
        } catch (error) {
            console.log('error', error);

            if (error.response && error.response.data && error.response.data.error) {
                const errorMessage = error.response.data.error;
                Swal.fire('Errore...', errorMessage, 'error');
            } else {
                Swal.fire('Errore...', error.message || 'Errore sconosciuto', 'error');
            }
        }
    };

    const handleConfirm = async () => {
        if (selectedOption === 'PDF') {
            await handlePDFUpload();
        } else if (selectedOption === 'XML') {
            await handleXMLUpload();
        }
    };

    const handleToggleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
    };

    return (
        <Transition.Root show={true} as={Fragment}>
            <Dialog as="div" className="fixed inset-0 top-20 overflow-y-auto" style={{ zIndex: 200}} onClose={closeModalUploadUnilav} initialFocus={cancelButtonRef}>
                <div className="flex items-start min-h-screen px-4 text-center sm:block sm:p-0 top-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-black opacity-70" />
                    </Transition.Child>

                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="inline-block bg-white rounded-lg px-5 py-2 text-left overflow-hidden shadow-xl transform transition-all  md:w-1/3 top-0">
                            
                            <div className="mt-2 pb-2 border-b border-gray-200 text-center flex items-center justify-center">
                                <ArrowUpTrayIcon className="h-5 w-5 text-gray-700" /><span className='w-4'></span>
                                <Dialog.Title as="h3" className="text-md font-medium text-gray-700">
                                    CARICA UNILAV
                                </Dialog.Title>
                            </div>
                            
                            <div className='grid grid-cols-1'>
                                <div className='col-span-1 flex justify-center items-center py-4'>
                                    <Toggle 
                                        color='indigo'
                                        gradeBgColor='600'
                                        optionLeft='PDF'
                                        optionRight='XML'
                                        selectedOption={selectedOption}
                                        onChange={handleToggleChange}
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col mx-4 pb-0">
                                {selectedOption === "PDF" && <PDFUpladUnilav onFileChange={uploadFile} onTypeChange={handleTypeChange} />}
                                {selectedOption === "XML" && <XMLUploadUnilav onXmlUploaded={uploadFile} />}
                            </div>

                            <div className="my-5 pb-5 sm:mt-6 flex justify-center">
                                <button
                                    type="button"
                                    className="bg-indigo-600 text-xs flex justify-center items-center shadow-md rounded-md w-full text-white font-bold btn-xs p-2 mx-4"
                                    onClick={handleConfirm}
                                    ref={cancelButtonRef}
                                >
                                    UPLOAD
                                </button>
                            </div>
                            {response && <div className="text-center text-red-500">{response}</div>}
                            <div className="m-4 mt-4 border-t flex justify-end">
                                <button
                                    type="button"
                                    className="bg-gray-300 mt-4 text-xs items-center shadow-md rounded-md  w-40 text-white font-bold btn-xs p-2"
                                    onClick={closeModalUploadUnilav}
                                    ref={cancelButtonRef}
                                >
                                    ANNULLA
                                </button>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    );
};

export default UploadUnilavEmployee;
